import { render, staticRenderFns } from "./LabelManager.vue?vue&type=template&id=5a09c917&scoped=true&"
import script from "./LabelManager.vue?vue&type=script&lang=ts&"
export * from "./LabelManager.vue?vue&type=script&lang=ts&"
import style0 from "./LabelManager.vue?vue&type=style&index=0&id=5a09c917&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a09c917",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VContainer,VRow,VSimpleTable})
